var exports = {
  "M6": "x43aef4ae--1ba99a--slide",
  "$_": "x43aef4ae--1ba99a--media",
  "Sl": "x43aef4ae--1ba99a--image",
  "Qs": "x43aef4ae--1ba99a--content",
  "tp": "x43aef4ae--1ba99a--content-inner",
  "G8": "x43aef4ae--1ba99a--main-content",
  "DD": "x43aef4ae--1ba99a--title",
  "VA": "x43aef4ae--1ba99a--subtitle",
  "HE": "x43aef4ae--1ba99a--button-wrapper",
  "ed": "x43aef4ae--1ba99a--disclaimer",
};

module.exports = exports;
